export default function() {
    return {
        isLoggedIn: false,
        isLoggedInEVM: false,
        isNative: false,
        address: null,
        nativeAccount: null,
    };
}
